import { useAuth } from '@/hooks/useAuth';
import { makeRequest } from '@/network/api';
import { PlumeDailySpinData, PlumeRaffleUserPrizeData } from '@/types';
import { useAppKitAccount } from '@reown/appkit/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';

export const useDailySpinOffchain = () => {
  const { isAuthenticated } = useAuth();
  const { address } = useAppKitAccount();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['dailySpinData', address],
    queryFn: async (): Promise<PlumeDailySpinData> => {
      const res = await makeRequest(`stats/dailySpinData?walletAddress=${address}`);
      const retData = await res.json();
      return retData?.data;
    },
    enabled: isAuthenticated,
  });

  const hasUnclaimedRaffleWin = useMemo(() => {
    return (
      data &&
      data.raffleUserPrizeData &&
      data.raffleUserPrizeData.some((prize: PlumeRaffleUserPrizeData) => prize.isPrizeWinner && !prize.didClaimPrize)
    );
  }, [data]);

  // Refetch data when authentication status or wallet address changes
  useEffect(() => {
    refetch();
  }, [isAuthenticated, address, refetch]);

  return {
    spinHistory: data?.spinHistory,
    raffleUserPrizeData: data?.raffleUserPrizeData,
    lastWeekRaffleWinner: data?.lastWeekRaffleWinner,
    totalSpinPlumeRewards: data?.totalSpinPlumeRewards,
    hasUnclaimedRaffleWin,
    isLoading,
    refetch,
  };
};
